export default {
  mesa: "Mesa",
  product: "Producto",
  quantity: "Cantidad",
  price: "Precio",
  total: "Total de la cuenta",
  totalPaid: "Total Pagado",
  baseTax: "Base imponible",
  VAT: "IVA",
  paymentMethod: "Forma de pago",
  pagado: "Pagado"
};
